import { ResourceOptions } from 'react-admin';
import { FaStream } from 'react-icons/fa';
import { Resources } from '../../resource';

import './dataProvider';

export { default as list } from './List';

export const name = Resources.blindBoxRewardFeed;
export const icon = FaStream;
export const options: ResourceOptions = {
  label: 'module.blindBox.rewardFeed',
};

